const POS_APP_MESSAGE_TYPE = 'kassa-web.SAVE_PDF_REQUESTED'

export const isInPOSWebView = () =>
	typeof window !== 'undefined' &&
	Boolean(window.ReactNativeWebView) &&
	typeof window.ReactNativeWebView.postMessage === 'function'

const blobToBase64 = (blob) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onloadend = () => {
			const dataUrl = String(reader.result)
			// strip "data:application/pdf;base64," prefix → just the base64 payload
			const base64 = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl
			resolve(base64)
		}
		reader.onerror = () => reject(reader.error)
		reader.readAsDataURL(blob)
	})

const saveViaPostMessage = async (pdf, filename) => {
	const blob = pdf.output('blob')
	const base64 = await blobToBase64(blob)
	window.ReactNativeWebView.postMessage(JSON.stringify({
		type: POS_APP_MESSAGE_TYPE,
		data: { filename, base64, mimeType: 'application/pdf' },
	}))
}

const saveViaInlineOpen = (pdf) => {
	const dataUrl = pdf.output('dataurlstring')
	if (typeof window !== 'undefined' && typeof window.open === 'function') {
		window.open(dataUrl, '_blank')
	}
}

/**
 * Save the rendered PDF to disk or to the native app's Share Sheet.
 *
 * Browser:    pdf.save(filename) — triggers download in Downloads folder.
 * POS WebView (LIEFERSOFT POS app): postMessage to RN host with base64.
 *             If postMessage throws — falls back to inline window.open.
 */
export const savePdfOutput = async (pdf, filename) => {
	if (!isInPOSWebView()) {
		pdf.save(filename)
		return
	}
	try {
		await saveViaPostMessage(pdf, filename)
	} catch (e) {
		saveViaInlineOpen(pdf)
	}
}
